import { StarOutlined } from "@ant-design/icons";

export default function Pill({ text, type = "default", onClick = null, styles = null }) {
    return (
        <span className={`pill-border tag mt-1 --type-${type}`} onClick={onClick} style={styles}>
            {type === "highlighted" && <StarOutlined />}

            {text}
        </span>
    );
}
